/* eslint react/jsx-props-no-spreading: off */ // --> eslint says prop spreading fine for HOC

import MUISkeleton, { SkeletonProps } from '@mui/material/Skeleton';

export default function Skeleton(props: SkeletonProps) {
    // if change skeleton className attribute, update getSection() function on etf details page
    return <MUISkeleton {...props} className='analytics-cfra-skeleton' />;
}
